import { render, staticRenderFns } from "./IndividualInfoTitle.vue?vue&type=template&id=9ef5428c&scoped=true"
import script from "./IndividualInfoTitle.vue?vue&type=script&lang=js"
export * from "./IndividualInfoTitle.vue?vue&type=script&lang=js"
import style0 from "./IndividualInfoTitle.vue?vue&type=style&index=0&id=9ef5428c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef5428c",
  null
  
)

export default component.exports